<div class="m-preview__link m-link" *ngIf="preview" (click)="navigate()">
    <img class="m-cover" [src]="preview.cover" *ngIf="preview.cover">
    <div class="m-preview__content">
        <p class="m-preview__site">{{ link }}</p>
        <p [attr.class]="'m-preview__title ' + class">{{ preview.title }}</p>
        <p class="m-preview__summary">{{ preview.description }}</p>
    </div>
</div>
